import { Client, EventSpecs, SessionData, PaperUploadData } from '@chegg/analytics-frontend'
import { Target } from 'redux-beacon'
import { EVENT_TYPES, PAPER_UPLOAD_STATES } from './constants'
import { Event, WtaState } from './types'

const wtaAnalytics = (): Target => (events: Event[]) => {
  if (typeof window === 'undefined') {
    return
  }

  events.forEach((event: Event) => {
    if (typeof event === 'object') {
      window.wtaCmd.push((client: Client) => {
        const meta = {
          eventTime: new Date(),
        }

        if (event.type === EVENT_TYPES.PAGEVIEW && event.pageType) {
          client.utils.updateState({ pageType: event.pageType })
          delete event.pageType
        }

        const { data, type } = event
        let force: boolean = false

        // check for paper upload end event
        if (type === EVENT_TYPES.PAPER_UPLOAD && (<PaperUploadData>data).state === PAPER_UPLOAD_STATES.end) {
          force = true
        }

        const eventData: EventSpecs = { data, meta, type }
        client.event(eventData, { force })
      })
    }
  })
}

export const initializeWtaClient = (options: SessionData) => {
  window.wtaCmd = window.wtaCmd || []
  const callback = (client: Client) => {
    client.init(options)
  }
  window.wtaCmd.push(callback)
}

export const updateState = (state: WtaState) => {
  window.wtaCmd = window.wtaCmd || []
  const callback = (client: Client) => {
    client.utils.updateState({ ...state })
  }
  window.wtaCmd.push(callback)
}

export default wtaAnalytics
